import { BadgeVariants } from '@carboledger/ui';
import { ACCESS_STATUS } from './accessStatus';
import { ACTIVITY_MODULE } from './activityModules';

// Badge variant per enum code; kept apart from the vocabularies, which mappers import.

export const ACCESS_STATUS_TONE = Object.freeze({
  [ACCESS_STATUS.active]: BadgeVariants.success,
  [ACCESS_STATUS.pendingInvitation]: BadgeVariants.warning,
  [ACCESS_STATUS.removedAccess]: BadgeVariants.default,
});

export const ACTIVITY_MODULE_TONE = Object.freeze({
  [ACTIVITY_MODULE.accountSetup]: BadgeVariants.info,
  [ACTIVITY_MODULE.adminCentre]: BadgeVariants.default,
  [ACTIVITY_MODULE.inbounds]: BadgeVariants.success,
  [ACTIVITY_MODULE.outbounds]: BadgeVariants.error,
  [ACTIVITY_MODULE.suppliers]: BadgeVariants.warning,
  [ACTIVITY_MODULE.customers]: BadgeVariants.warning,
  [ACTIVITY_MODULE.operations]: BadgeVariants.default,
  [ACTIVITY_MODULE.production]: BadgeVariants.default,
  [ACTIVITY_MODULE.other]: BadgeVariants.default,
});
